import type {
  TAssistantErrorBody,
  TAssistantErrorCode,
} from '@/interfaces/assistant.interface';

const ASSISTANT_ERROR_CODES: readonly TAssistantErrorCode[] = [
  'ASSISTANT_WRITES_OFF',
  'ASSISTANT_FORBIDDEN',
  'ASSISTANT_PLAN_REQUIRED',
  'ASSISTANT_ORIGIN',
  'ASSISTANT_NOT_FOUND',
  'ASSISTANT_STALE',
  'ASSISTANT_SUPERSEDED',
  'ASSISTANT_NOT_PENDING',
  'ASSISTANT_UNDO_WINDOW',
  'ASSISTANT_EXPIRED',
  'ASSISTANT_INVALID_OP',
  'ASSISTANT_TOO_MANY_ROWS',
  'ASSISTANT_QUOTA',
  'ASSISTANT_UPDATE_REQUIRED',
  'ASSISTANT_IDENTITY_OFF',
];

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/**
 * An Action API error body (plan §3.8): its `code` is one of the assistant
 * codes; the server's contract types the `details` of each code.
 */
export function isAssistantErrorBody(
  value: unknown
): value is TAssistantErrorBody {
  return (
    isRecord(value) &&
    typeof value.statusCode === 'number' &&
    typeof value.code === 'string' &&
    (ASSISTANT_ERROR_CODES as readonly string[]).includes(value.code)
  );
}

/** The Action API error of a failed request; null for network errors and other failures. */
export function readAssistantError(error: unknown): TAssistantErrorBody | null {
  if (!isRecord(error) || !isRecord(error.response)) return null;
  const data = error.response.data;
  return isAssistantErrorBody(data) ? data : null;
}
